import { render, staticRenderFns } from "./ChoosePermissionMulti.vue?vue&type=template&id=1d1343b8&scoped=true"
import script from "./ChoosePermissionMulti.vue?vue&type=script&lang=js"
export * from "./ChoosePermissionMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1343b8",
  null
  
)

export default component.exports